<template>
  <ion-page>
    <ion-progress-bar :value="0" v-show="$store.state.hide"></ion-progress-bar>
    <ion-content>
      <header-section />

      <div class="site-container">
        <!-- Start of create post modal-->
        <div
          class="create-modal-popup"
          id="modal-interface"
          v-if="$store.state.authuser"
        >
          <div class="modal-content" id="modal-content">
            <div
              class="modal-header"
              style="display: flex; justify-content: center"
            >
              <h3 style="font-weight: 900">Create post</h3>
              <div class="cancel" id="closeBtn">
                <i><svg-icon name="multiply" /></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="modal-title">
                <div class="profile-image" v-if="$store.state.authuser">
                  <img
                    :src="`https://hyreads.com/${$store.state.authuser.image}`"
                    alt=""
                  />
                </div>
                <h5>
                  <b>{{ $store.state.authuser.username }}</b
                  ><span v-if="checked.length != 0"
                    >&nbsp;is with <b>{{ checked[0].name }}</b
                    ><span v-if="checked.length > 1">
                      and &nbsp;<b>{{ checked.length - 1 }}</b>
                      <span v-if="checked.length > 2">&nbsp;Others</span
                      ><span v-else>&nbsp;Other</span></span
                    ></span
                  ><br />

                  <div class="select">
                    <select name="category" id="category" ref="status" required>
                      <option>Public</option>
                      <option>Friends</option>
                    </select>
                  </div>
                </h5>
              </div>
              <!-- <form action="" method="post"> -->
              <textarea
                id="textarea"
                v-model="description"
                ref="roomTextarea"
                class="textarea-control"
                cols="30"
                rows="2"
                :placeholder="`What's on your mind, ${$store.state.authuser.username}?`"
                @input="onChangeInput"
              ></textarea>
              <div>
                <div class="vac-media-file">
                  <span v-for="(image, index) in imageFile" :key="index">
                    <div
                      class="vac-svg-button vac-icon-media"
                      @click="removeFile(index)"
                    >
                      <slot name="image-close-icon">
                        <svg-icon name="close" param="image" />
                      </slot>
                    </div>
                    <img :src="image" />
                  </span>
                </div>
              </div>
              <div v-if="isVideo" class="vac-media-container">
                <div class="vac-media-file">
                  <span v-for="(vide, index) in videoFile" :key="index">
                    <div
                      class="vac-svg-button vac-icon-media"
                      @click="removeFile1(index)"
                    >
                      <slot name="image-close-icon">
                        <svg-icon name="close" param="image" />
                      </slot>
                    </div>
                    <video style="width: 100%; height: 100%" controls>
                      <source :src="vide" type="video/mp4" />
                      <source :src="vide" type="video/ogg" />
                      <source :src="vide" type="video/webm" />
                    </video>
                  </span>
                </div>
              </div>
              <div class="additions">
                <div class="upload">
                  <div class="addition">
                    <h2>Add to your post</h2>
                    <input
                      ref="files"
                      type="file"
                      id="read-file"
                      multiple
                      hidden
                      @change="onFileChange($event.target.files)"
                    />
                    <div class="upload">
                      <div id="uploadBtn" @click="act">
                        <img
                          style="width: 25px"
                          :src="`https://hyreads.com/images/picture.png`"
                          alt=""
                        />
                      </div>
                      <div class="pollBtn">
                        <svg-icon name="poll" />
                      </div>
                      <div class="tagBtn">
                        <img
                          style="width: 35px"
                          :src="`https://hyreads.com/images/tag.png`"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                type="submit"
                @click.prevent="feed()"
                class="post-submitt"
              >
                <span v-if="uploadPercentage"
                  >Uploading
                  <span style="color: red">{{ uploadPercentage }}%</span></span
                ><span v-else> Post</span>
              </button>
            </div>
            <!-- Tags Section -->
            <div class="tag-body">
              <div class="tag-title">
                <span class="remove-tags-btn"
                  ><i><svg-icon name="arrow-left" /></i
                ></span>
                <h2>Tag a Friend</h2>
              </div>

              <div class="tag-search">
                <div class="search-box">
                  <i><svg-icon name="searching" /></i>
                  <input
                    type="text"
                    name=""
                    class="search-friends"
                    placeholder="Search for friends"
                    v-model="search"
                  />
                </div>
                <button class="remove-exit-btn">Done</button>
              </div>
              <h3>Suggestions</h3>
              <div class="suggestions">
                <div class="suggested-friends">
                  <div
                    class="friend"
                    v-for="(tag, index) in allTags"
                    :key="index"
                  >
                    <div class="friend-name">
                      <div class="profile-image">
                        <img
                          :src="
                            $store.state.authuser &&
                            tag.sender.id == $store.state.authuser.id
                              ? `${this.$store.state.endpoints.appUrl}${tag.receiver.image}`
                              : `${this.$store.state.endpoints.appUrl}${tag.sender.image}`
                          "
                          alt=""
                        />
                      </div>
                      <h4>
                        {{
                          $store.state.authuser &&
                          tag.sender.id == $store.state.authuser.id
                            ? `${tag.receiver.username}`
                            : `${tag.sender.username}`
                        }}
                      </h4>
                    </div>
                    <input
                      type="checkbox"
                      name=""
                      id="mainCat.merchantId"
                      :value="
                        userIdObj(
                          $store.state.authuser &&
                            tag.sender.id == $store.state.authuser.id
                            ? `${tag.receiver.username}`
                            : `${tag.sender.username}`
                        )
                      "
                      v-model="checked"
                      class="check-control"
                      @change="addTag($event)"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="poll-body">
              <div class="tag-title">
                <span class="remove-polls-btn"
                  ><i><svg-icon name="arrow-left" /></i
                ></span>
                <h2>Create a Poll</h2>
              </div>
              <div class="suggestions1 mt-2 mb-2">
                <create-poll @poll="addVote" />
              </div>
            </div>
          </div>
        </div>
        <div class="main-wrapper" v-if="$store.state.authuser">
          <div class="inner-row">
            <div class="left-container">
              <div class="sidebar">
                <router-link to="/home" class="nav-link active">
                  <i><svg-icon name="home" /></i>
                  <span class="mt-2"> Home</span>
                </router-link>
                <router-link to="" class="nav-link">
                  <i><svg-icon name="club" /></i>
                  <span> <span class="mt-2">Forums</span> </span>
                </router-link>
                <router-link to="/chatroom" class="nav-link">
                  <i><svg-icon name="envelope" /></i>
                  <span> <span class="mt-2">Messages</span> </span>
                </router-link>
                <router-link to="/notifications" class="nav-link">
                  <i><svg-icon name="bell" /></i>
                  <span> <span class="mt-2">Notifications</span> </span>
                </router-link>

                <router-link to="" class="nav-link">
                  <i><svg-icon name="diary" /></i>
                  <span class="mt-2">Tasks</span>
                </router-link>
                <!-- <router-link to="/campus" class="nav-link">
                  <i><svg-icon name="books" /></i>
                  <span class="mt-2">Campus Cafe</span>
                </router-link> -->
                <router-link
                  :to="`/profile/${$store.state.authuser.id}`"
                  class="nav-link"
                >
                  <i><svg-icon name="user"></svg-icon></i>
                  <span class="mt-2"> Profile</span>
                </router-link>
              </div>
            </div>

            <div class="middle-container">
              <reads
                :authuser="$store.state.authuser"
                title=""
                :stories="$store.state.stories"
              />

              <div class="create-post" id="create-post">
                <div
                  class="profile-image"
                  v-if="$store.state.authuser.image !== $store.state.avatar"
                >
                  <img
                    :src="`${this.$store.state.endpoints.appUrl}${$store.state.authuser.image}`"
                    alt=""
                  />
                </div>
                <div v-else>
                  <avatar
                    :username="$store.state.authuser.username"
                    style="width: 2rem; height: 2rem"
                  ></avatar>
                </div>
                <input
                  type="text"
                  name=""
                  class=""
                  :placeholder="`What's on your mind, ${$store.state.authuser.username}?`"
                />

                <input type="submit" value="Post" class="btn-post" />
              </div>
              <div class="posts" v-show="$store.state.allPostLoader">
                <div class="facebook-card d-flex" style="display: flex">
                  <vue-skeleton-loader
                    type="circle"
                    :width="50"
                    :height="50"
                    animation="fade"
                  />
                  <span style="margin-top: 19px; margin-left: 6px">
                    <vue-skeleton-loader
                      type="rect"
                      :width="260"
                      :height="10"
                      :rounded="true"
                      animation="fade"
                  /></span>
                </div>
                <div class="facebook-card">
                  <span style="margin-left: 6px; max-width: 100%">
                    <vue-skeleton-loader
                      type="rect"
                      :width="330"
                      :height="10"
                      :rounded="true"
                      animation="fade"
                  /></span>
                  <span
                    style="margin-top: 9px; margin-left: 6px; max-width: 100%"
                  >
                    <vue-skeleton-loader
                      type="rect"
                      :width="330"
                      :height="10"
                      :rounded="true"
                      animation="fade"
                  /></span>
                  <span
                    style="margin-top: 9px; margin-left: 6px; max-width: 100%"
                  >
                    <vue-skeleton-loader
                      type="rect"
                      :width="330"
                      :height="10"
                      :rounded="true"
                      animation="fade"
                  /></span>
                </div>
                <!-- second loader -->
                <div
                  class="facebook-card d-flex"
                  style="display: flex; margin-top: 10px"
                >
                  <vue-skeleton-loader
                    type="circle"
                    :width="50"
                    :height="50"
                    animation="fade"
                  />
                  <span style="margin-top: 19px; margin-left: 6px">
                    <vue-skeleton-loader
                      type="rect"
                      :width="260"
                      :height="10"
                      :rounded="true"
                      animation="fade"
                  /></span>
                </div>
                <div class="facebook-card">
                  <span style="margin-left: 6px; max-width: 100%">
                    <vue-skeleton-loader
                      type="rect"
                      :width="330"
                      :height="10"
                      :rounded="true"
                      animation="fade"
                  /></span>
                  <span
                    style="margin-top: 9px; margin-left: 6px; max-width: 100%"
                  >
                    <vue-skeleton-loader
                      type="rect"
                      :width="330"
                      :height="10"
                      :rounded="true"
                      animation="fade"
                  /></span>
                  <span
                    style="margin-top: 9px; margin-left: 6px; max-width: 100%"
                  >
                    <vue-skeleton-loader
                      type="rect"
                      :width="330"
                      :height="10"
                      :rounded="true"
                      animation="fade"
                  /></span>
                </div>
              </div>
              <div
                class="posts"
                v-for="(post, index) in $store.state.feeds"
                :key="index"
              >
                <div class="post" v-if="post.polls && post.polls.length">
                  <div class="post-head">
                    <div class="user">
                      <div class="profile-image">
                        <img
                          :src="`${this.$store.state.endpoints.appUrl}${post.user.image}`"
                          alt=""
                        />
                      </div>
                      <div class="namlo">
                        <h3>
                          {{ post.user.username }}&nbsp;<span
                            v-if="post.tags.length != 0"
                            style="font-size: 10px"
                            >With
                            <b>{{
                              post.tags
                                .slice(0, 1)
                                .map((x) => x.username)
                                .join("&")
                            }}</b>
                            <span v-if="post.tags.length > 1"
                              >&nbsp;and {{ post.tags.length - 1 }}
                              <span v-if="post.tags.length > 2">Others</span
                              ><span v-else>Other</span></span
                            ></span
                          >
                        </h3>
                        <small
                          >{{ post.city }}<span v-if="post.city">,</span>
                          {{ post.country_name }}
                          <span v-if="post.country_name">,</span>
                          {{ getHumanDate(post.created_at) }}</small
                        >
                      </div>
                    </div>
                    <span
                      ><i><svg-icon name="ellipsis" /></i
                    ></span>
                  </div>
                  <div class="sentence-post">
                    <p>
                      <vue-poll
                        :index="index"
                        :id="post.id"
                        :finalResults="post.finalResults"
                        :options="
                          post.polls.map((ite, i) => {
                            return {
                              question: ite.question,
                              finalResults: ite.finalResults,
                              answers: ite.choices.map((item, i) => {
                                return {
                                  value: i,
                                  text: item.answer,
                                  votes: item.votes,
                                  id: item.id,
                                  question_id: ite.id,
                                };
                              }),
                            };
                          })
                        "
                      />
                    </p>
                  </div>

                  <div class="action-btns">
                    <div class="left-side-btns">
                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-if="
                          (post.fliked &&
                            post.reacted &&
                            post.your_reaction.reaction == '❤️') ||
                          (!post.reacted && post.fliked)
                        "
                      >
                        <template #icon
                          ><feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                        /></template>
                      </vue-star>

                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-else-if="post.fliked && post.reacted"
                        @click="post.popup = true"
                      >
                        <template #icon>
                          <feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                          />
                        </template>
                      </vue-star>
                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-else
                      >
                        <template #icon>
                          <feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                          />
                        </template>
                      </vue-star>
                    </div>
                    <div class="interaction-btns">
                      <span class="commentBtn" v-if="post.commentBox === false"
                        ><i @click.prevent="commentBox(post.id, index)"
                          ><svg-icon name="comment-dots" /></i
                      ></span>
                      <span class="commentBtn" v-else
                        ><i @click.prevent="post.commentBox = false"
                          ><svg-icon name="comment-dots" /></i
                      ></span>
                      <span
                        ><navigator-share
                          style="cursor: pointer"
                          v-bind:on-error="onError"
                          v-bind:on-success="onCopy"
                          :title="`${post.description}`"
                          text=""
                        >
                        </navigator-share
                      ></span>
                    </div>

                    <div class="bookmark" style="float: right">
                      <span v-if="post.bookmarked"
                        ><i style="fill: red"><svg-icon name="bookmark" /></i
                      ></span>
                      <span
                        v-else
                        @click="bookmarked1(post.id), (post.bookmarked = true)"
                        ><i><svg-icon name="bookmark" /></i
                      ></span>
                    </div>
                  </div>
                  <div class="people-likings">
                    <span
                      v-for="(like, index) in post.likes && post.likes.length
                        ? post.likes.slice(-5)
                        : []"
                      :key="index"
                    >
                      <img
                        :src="`${$store.state.endpoints.appUrl}${like.user.image}`"
                        alt=""
                        v-if="
                          like &&
                          like.user &&
                          like.user.image !== $store.state.avatar
                        "
                      />
                      <avatar
                        :username="
                          like.user
                            ? like.user.name
                            : $store.state.authuser.name
                        "
                        style="width: 1.4rem; height: 1.4rem"
                        v-else
                      ></avatar>
                    </span>
                    <p v-if="post.likes && post.likes.length">
                      <small v-if="post.likes && post.reacts.length == 0"
                        >❤️</small
                      ><small v-for="(react, index) in post.reacts" :key="index"
                        >{{ react.reaction }}
                      </small>

                      <b
                        v-for="(postername, index) in post.likes.slice(-1)"
                        :key="index"
                        ><b
                          v-if="
                            postername &&
                            $store.state.authuser.id === postername.user.id
                          "
                        >
                          You </b
                        ><b v-else>
                          {{
                            postername && postername.user
                              ? postername.user.username
                              : this.$store.state.authuser.username
                          }}</b
                        ></b
                      >
                      <em v-if="post.likes.length - 1 != 0"> and </em>
                      <b
                        ><em v-if="post.likes.length - 1 != 0">{{
                          post.likes.length - 1
                        }}</em>
                        <b v-if="post.likes.length - 1 > 1"> others</b
                        ><b v-else
                          ><em v-if="post.likes.length - 1 != 0"> other</em></b
                        ></b
                      >
                    </p>
                  </div>

                  <div
                    class="caption"
                    v-if="post.comments && post.comments.length"
                  >
                    <comment
                      :comment="comment"
                      :collection="comment.children"
                      v-for="(comment, index) in post.comments.slice(-2)"
                      :key="index"
                    ></comment>
                  </div>
                  <div
                    class="comments"
                    v-if="post.comments && post.comments.length"
                    @click="$router.push(`/post/${post.id}`)"
                  >
                    View all {{ post.comments.length }} comment<span
                      v-if="post.comments.length != 1"
                      >s</span
                    >
                  </div>

                  <div class="create-comment" v-if="post && post.commentBox">
                    <div class="profile-image">
                      <img
                        :src="`https://hyreads.com/${this.$store.state.authuser.image}`"
                        alt=""
                      />
                    </div>
                    <div class="input-comment">
                      <textarea
                        name=""
                        class="comment-control"
                        cols="20"
                        rows="10"
                        v-model="comment"
                        v-on:keyup.enter="newComment(post.id, index)"
                        placeholder="Write a comment..."
                      ></textarea>
                    </div>
                    <span @click="newComment(post.id, index)">
                      <i><svg-icon name="message" /></i>
                    </span>
                  </div>
                </div>
                <div class="post" v-else-if="post.videos && post.videos.length">
                  <div class="post-head">
                    <div class="user">
                      <div class="profile-image">
                        <img
                          :src="`${this.$store.state.endpoints.appUrl}${post.user.image}`"
                          alt=""
                        />
                      </div>
                      <div class="namlo">
                        <h3>
                          {{ post.user.username }}&nbsp;<span
                            v-if="post.tags.length != 0"
                            style="font-size: 10px"
                            >With
                            <b>{{
                              post.tags
                                .slice(0, 1)
                                .map((x) => x.username)
                                .join("&")
                            }}</b>
                            <span v-if="post.tags.length > 1"
                              >&nbsp;and {{ post.tags.length - 1 }}
                              <span v-if="post.tags.length > 2">Others</span
                              ><span v-else>Other</span></span
                            ></span
                          >
                        </h3>
                        <small
                          >{{ post.city }}<span v-if="post.city">,</span>
                          {{ post.country_name }}
                          <span v-if="post.country_name">,</span>
                          {{ getHumanDate(post.created_at) }}</small
                        >
                      </div>
                    </div>
                    <span
                      ><i><svg-icon name="ellipsis" /></i
                    ></span>
                  </div>
                  <div class="sentence-post">
                    {{ post.description }}
                  </div>
                  <div class="video-post">
                    <video
                      style="width: 100%; height: 100%; border-radius: 20px"
                      controls
                      autoplay
                      muted
                    >
                      <source
                        :src="`${this.$store.state.endpoints.appUrl}${post.videos[0].video}`"
                        type="video/mp4"
                      />
                      <source
                        :src="`${this.$store.state.endpoints.appUrl}${post.videos[0].video}`"
                        type="video/ogg"
                      />
                      <source
                        :src="`${this.$store.state.endpoints.appUrl}${post.videos[0].video}`"
                        type="video/webm"
                      />
                    </video>
                  </div>

                  <div class="action-btns">
                    <div class="left-side-btns">
                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-if="
                          (post.fliked &&
                            post.reacted &&
                            post.your_reaction.reaction == '❤️') ||
                          (!post.reacted && post.fliked)
                        "
                      >
                        <template #icon
                          ><feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                        /></template>
                      </vue-star>

                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-else-if="post.fliked && post.reacted"
                        @click="post.popup = true"
                      >
                        <template #icon>
                          <feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                          />
                        </template>
                      </vue-star>
                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-else
                      >
                        <template #icon>
                          <feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                          />
                        </template>
                      </vue-star>
                    </div>
                    <div class="interaction-btns">
                      <span class="commentBtn" v-if="post.commentBox === false"
                        ><i @click.prevent="commentBox(post.id, index)"
                          ><svg-icon name="comment-dots" /></i
                      ></span>
                      <span class="commentBtn" v-else
                        ><i @click.prevent="post.commentBox = false"
                          ><svg-icon name="comment-dots" /></i
                      ></span>
                      <span
                        ><navigator-share
                          style="cursor: pointer"
                          v-bind:on-error="onError"
                          v-bind:on-success="onCopy"
                          :title="`${post.description}`"
                          text=""
                        >
                        </navigator-share
                      ></span>
                    </div>

                    <div class="bookmark" style="float: right">
                      <span v-if="post.bookmarked"
                        ><i style="fill: red"><svg-icon name="bookmark" /></i
                      ></span>
                      <span
                        v-else
                        @click="bookmarked1(post.id), (post.bookmarked = true)"
                        ><i><svg-icon name="bookmark" /></i
                      ></span>
                    </div>
                  </div>
                  <div class="people-likings">
                    <span
                      v-for="(like, index) in post.likes && post.likes.length
                        ? post.likes.slice(-5)
                        : []"
                      :key="index"
                    >
                      <img
                        :src="`${$store.state.endpoints.appUrl}${like.user.image}`"
                        alt=""
                        v-if="
                          like &&
                          like.user &&
                          like.user.image !== $store.state.avatar
                        "
                      />
                      <avatar
                        :username="
                          like.user
                            ? like.user.name
                            : $store.state.authuser.name
                        "
                        style="width: 1.4rem; height: 1.4rem"
                        v-else
                      ></avatar>
                    </span>
                    <p v-if="post.likes && post.likes.length">
                      <small v-if="post.likes && post.reacts.length == 0"
                        >❤️</small
                      ><small v-for="(react, index) in post.reacts" :key="index"
                        >{{ react.reaction }}
                      </small>

                      <b
                        v-for="(postername, index) in post.likes.slice(-1)"
                        :key="index"
                        ><b
                          v-if="
                            postername &&
                            $store.state.authuser.id === postername.user.id
                          "
                        >
                          You </b
                        ><b v-else>
                          {{
                            postername && postername.user
                              ? postername.user.username
                              : this.$store.state.authuser.username
                          }}</b
                        ></b
                      >
                      <em v-if="post.likes.length - 1 != 0"> and </em>
                      <b
                        ><em v-if="post.likes.length - 1 != 0">{{
                          post.likes.length - 1
                        }}</em>
                        <b v-if="post.likes.length - 1 > 1"> others</b
                        ><b v-else
                          ><em v-if="post.likes.length - 1 != 0"> other</em></b
                        ></b
                      >
                    </p>
                  </div>

                  <div
                    class="caption"
                    v-if="post.comments && post.comments.length"
                  >
                    <comment
                      :comment="comment"
                      :collection="comment.children"
                      v-for="(comment, index) in post.comments.slice(-2)"
                      :key="index"
                    ></comment>
                  </div>
                  <div
                    class="comments"
                    v-if="post.comments && post.comments.length"
                    @click="$router.push(`/post/${post.id}`)"
                  >
                    View all {{ post.comments.length }} comment<span
                      v-if="post.comments.length != 1"
                      >s</span
                    >
                  </div>

                  <div class="create-comment" v-if="post && post.commentBox">
                    <div class="profile-image">
                      <img
                        :src="`https://hyreads.com/${this.$store.state.authuser.image}`"
                        alt=""
                      />
                    </div>
                    <div class="input-comment">
                      <textarea
                        name=""
                        class="comment-control"
                        cols="20"
                        rows="10"
                        v-model="comment"
                        v-on:keyup.enter="newComment(post.id, index)"
                        placeholder="Write a comment..."
                      ></textarea>
                    </div>
                    <span @click="newComment(post.id, index)">
                      <i><svg-icon name="message" /></i>
                    </span>
                  </div>
                </div>

                <div class="post" v-else-if="post.images && post.images.length">
                  <div class="post-head">
                    <div class="user">
                      <div class="profile-image">
                        <img
                          :src="`${this.$store.state.endpoints.appUrl}${post.user.image}`"
                          alt=""
                        />
                      </div>
                      <div class="namlo">
                        <h3>
                          {{ post.user.username }}&nbsp;<span
                            v-if="post.tags.length != 0"
                            style="font-size: 10px"
                            >With
                            <b>{{
                              post.tags
                                .slice(0, 1)
                                .map((x) => x.username)
                                .join("&")
                            }}</b>
                            <span v-if="post.tags.length > 1"
                              >&nbsp;and {{ post.tags.length - 1 }}
                              <span v-if="post.tags.length > 2">Others</span
                              ><span v-else>Other</span></span
                            ></span
                          >
                        </h3>
                        <small
                          >{{ post.city }}<span v-if="post.city">,</span>
                          {{ post.country_name }}
                          <span v-if="post.country_name">,</span>
                          {{ getHumanDate(post.created_at) }}</small
                        >
                      </div>
                    </div>
                    <span
                      ><i><svg-icon name="ellipsis" /></i
                    ></span>
                  </div>
                  <div class="sentence-post">
                    {{ post.description }}
                  </div>
                  <div class="post-photo">
                    <img
                      style="border-radius: 20px"
                      :src="`${this.$store.state.endpoints.appUrl}${post.images[0].image}`"
                      alt=""
                    />
                  </div>

                  <div class="action-btns">
                    <div class="left-side-btns">
                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-if="
                          (post.fliked &&
                            post.reacted &&
                            post.your_reaction.reaction == '❤️') ||
                          (!post.reacted && post.fliked)
                        "
                      >
                        <template #icon
                          ><feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                        /></template>
                      </vue-star>

                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-else-if="post.fliked && post.reacted"
                        @click="post.popup = true"
                      >
                        <template #icon>
                          <feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                          />
                        </template>
                      </vue-star>
                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-else
                      >
                        <template #icon>
                          <feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                          />
                        </template>
                      </vue-star>
                    </div>
                    <div class="interaction-btns">
                      <span class="commentBtn" v-if="post.commentBox === false"
                        ><i @click.prevent="commentBox(post.id, index)"
                          ><svg-icon name="comment-dots" /></i
                      ></span>
                      <span class="commentBtn" v-else
                        ><i @click.prevent="post.commentBox = false"
                          ><svg-icon name="comment-dots" /></i
                      ></span>
                      <span
                        ><navigator-share
                          style="cursor: pointer"
                          v-bind:on-error="onError"
                          v-bind:on-success="onCopy"
                          :title="`${post.description}`"
                          text=""
                        >
                        </navigator-share
                      ></span>
                    </div>

                    <div class="bookmark" style="float: right">
                      <span v-if="post.bookmarked"
                        ><i style="fill: red"><svg-icon name="bookmark" /></i
                      ></span>
                      <span
                        v-else
                        @click="bookmarked1(post.id), (post.bookmarked = true)"
                        ><i><svg-icon name="bookmark" /></i
                      ></span>
                    </div>
                  </div>
                  <div class="people-likings">
                    <span
                      v-for="(like, index) in post.likes && post.likes.length
                        ? post.likes.slice(-5)
                        : []"
                      :key="index"
                    >
                      <img
                        :src="`${$store.state.endpoints.appUrl}${like.user.image}`"
                        alt=""
                        v-if="
                          like &&
                          like.user &&
                          like.user.image !== $store.state.avatar
                        "
                      />
                      <avatar
                        :username="
                          like.user
                            ? like.user.name
                            : $store.state.authuser.name
                        "
                        style="width: 1.4rem; height: 1.4rem"
                        v-else
                      ></avatar>
                    </span>
                    <p v-if="post.likes && post.likes.length">
                      <small v-if="post.likes && post.reacts.length == 0"
                        >❤️</small
                      ><small v-for="(react, index) in post.reacts" :key="index"
                        >{{ react.reaction }}
                      </small>

                      <b
                        v-for="(postername, index) in post.likes.slice(-1)"
                        :key="index"
                        ><b
                          v-if="
                            postername &&
                            $store.state.authuser.id === postername.user.id
                          "
                        >
                          You </b
                        ><b v-else>
                          {{
                            postername && postername.user
                              ? postername.user.username
                              : this.$store.state.authuser.username
                          }}</b
                        ></b
                      >
                      <em v-if="post.likes.length - 1 != 0"> and </em>
                      <b
                        ><em v-if="post.likes.length - 1 != 0">{{
                          post.likes.length - 1
                        }}</em>
                        <b v-if="post.likes.length - 1 > 1"> others</b
                        ><b v-else
                          ><em v-if="post.likes.length - 1 != 0"> other</em></b
                        ></b
                      >
                    </p>
                  </div>

                  <div
                    class="caption"
                    v-if="post.comments && post.comments.length"
                  >
                    <comment
                      :comment="comment"
                      :collection="comment.children"
                      v-for="(comment, index) in post.comments.slice(-2)"
                      :key="index"
                    ></comment>
                  </div>
                  <div
                    class="comments"
                    v-if="post.comments && post.comments.length"
                    @click="$router.push(`/post/${post.id}`)"
                  >
                    View all {{ post.comments.length }} comment<span
                      v-if="post.comments.length != 1"
                      >s</span
                    >
                  </div>

                  <div class="create-comment" v-if="post && post.commentBox">
                    <div class="profile-image">
                      <img
                        :src="`https://hyreads.com/${this.$store.state.authuser.image}`"
                        alt=""
                      />
                    </div>
                    <div class="input-comment">
                      <textarea
                        name=""
                        class="comment-control"
                        cols="20"
                        rows="10"
                        v-model="comment"
                        v-on:keyup.enter="newComment(post.id, index)"
                        placeholder="Write a comment..."
                      ></textarea>
                    </div>
                    <span @click="newComment(post.id, index)">
                      <i><svg-icon name="message" /></i>
                    </span>
                  </div>
                </div>
                <div class="post" v-else>
                  <div class="post-head">
                    <div class="user">
                      <div class="profile-image">
                        <img
                          :src="`${this.$store.state.endpoints.appUrl}${post.user.image}`"
                          alt=""
                        />
                      </div>
                      <div class="namlo">
                        <h3>
                          {{ post.user.username }}&nbsp;<span
                            v-if="post.tags.length != 0"
                            style="font-size: 10px"
                            >With
                            <b>{{
                              post.tags
                                .slice(0, 1)
                                .map((x) => x.username)
                                .join("&")
                            }}</b>
                            <span v-if="post.tags.length > 1"
                              >&nbsp;and {{ post.tags.length - 1 }}
                              <span v-if="post.tags.length > 2">Others</span
                              ><span v-else>Other</span></span
                            ></span
                          >
                        </h3>
                        <small
                          >{{ post.city }}<span v-if="post.city">,</span>
                          {{ post.country_name }}
                          <span v-if="post.country_name">,</span>
                          {{ getHumanDate(post.created_at) }}</small
                        >
                      </div>
                    </div>
                    <span
                      ><i><svg-icon name="ellipsis" /></i
                    ></span>
                  </div>

                  <div class="sentence-post" v-html="post.description"></div>
                  <div class="action-btns">
                    <div class="left-side-btns">
                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-if="
                          (post.fliked &&
                            post.reacted &&
                            post.your_reaction.reaction == '❤️') ||
                          (!post.reacted && post.fliked)
                        "
                      >
                        <template #icon
                          ><i class="fa fa-heart" style="color: red"></i
                        ></template>
                      </vue-star>

                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-else-if="post.fliked && post.reacted"
                        @click="post.popup = true"
                      >
                        <template #icon
                          ><feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                        /></template>
                      </vue-star>
                      <vue-star
                        animate="animated bounceIn"
                        color="#F05654"
                        v-else
                      >
                        <template #icon
                          ><feed-reactions
                            :reaction="
                              post.your_reaction != null
                                ? post.your_reaction.reaction
                                : null
                            "
                            :feed_id="post.id"
                            :index="index"
                        /></template>
                      </vue-star>
                    </div>
                    <div class="interaction-btns">
                      <span class="commentBtn" v-if="post.commentBox === false"
                        ><i @click.prevent="commentBox(post.id, index)"
                          ><svg-icon name="comment-dots" /></i
                      ></span>
                      <span class="commentBtn" v-else
                        ><i @click.prevent="post.commentBox = false"
                          ><svg-icon name="comment-dots" /></i
                      ></span>
                      <span
                        ><navigator-share
                          style="cursor: pointer"
                          v-bind:on-error="onError"
                          v-bind:on-success="onCopy"
                          :title="`${post.description}`"
                          text=""
                        >
                        </navigator-share
                      ></span>
                    </div>

                    <div class="bookmark" style="float: right">
                      <span v-if="post.bookmarked"
                        ><i style="fill: red"><svg-icon name="bookmark" /></i
                      ></span>
                      <span
                        v-else
                        @click="bookmarked1(post.id), (post.bookmarked = true)"
                        ><i><svg-icon name="bookmark" /></i
                      ></span>
                    </div>
                  </div>
                  <div class="people-likings">
                    <span
                      v-for="(like, index) in post.likes && post.likes.length
                        ? post.likes.slice(-5)
                        : []"
                      :key="index"
                    >
                      <img
                        :src="`${$store.state.endpoints.appUrl}${like.user.image}`"
                        alt=""
                        v-if="
                          like &&
                          like.user &&
                          like.user.image !== $store.state.avatar
                        "
                      />
                      <avatar
                        :username="
                          like.user
                            ? like.user.name
                            : $store.state.authuser.name
                        "
                        style="width: 1.4rem; height: 1.4rem"
                        v-else
                      ></avatar>
                    </span>
                    <p v-if="post.likes && post.likes.length">
                      <small v-if="post.likes && post.reacts.length == 0"
                        >❤️</small
                      ><small v-for="(react, index) in post.reacts" :key="index"
                        >{{ react.reaction }}
                      </small>

                      <b
                        v-for="(postername, index) in post.likes.slice(-1)"
                        :key="index"
                        ><b
                          v-if="
                            postername &&
                            $store.state.authuser.id === postername.user.id
                          "
                        >
                          You </b
                        ><b v-else>
                          {{
                            postername && postername.user
                              ? postername.user.username
                              : this.$store.state.authuser.username
                          }}</b
                        ></b
                      >
                      <em v-if="post.likes.length - 1 != 0"> and </em>
                      <b
                        ><em v-if="post.likes.length - 1 != 0">{{
                          post.likes.length - 1
                        }}</em>
                        <b v-if="post.likes.length - 1 > 1"> others</b
                        ><b v-else
                          ><em v-if="post.likes.length - 1 != 0"> other</em></b
                        ></b
                      >
                    </p>
                  </div>
                  <div
                    class="caption"
                    v-if="post.comments && post.comments.length"
                  >
                    <comment
                      :comment="comment"
                      :collection="comment.children"
                      v-for="(comment, index) in post.comments.slice(-2)"
                      :key="index"
                    ></comment>
                  </div>
                  <div
                    class="comments"
                    v-if="post.comments && post.comments.length"
                    @click="$router.push(`/post/${post.id}`)"
                  >
                    View all {{ post.comments.length }} comment<span
                      v-if="post.comments.length != 1"
                      >s</span
                    >
                  </div>

                  <div class="create-comment" v-if="post && post.commentBox">
                    <div class="profile-image">
                      <img
                        :src="`https://hyreads.com/${this.$store.state.authuser.image}`"
                        alt=""
                      />
                    </div>
                    <div class="input-comment">
                      <textarea
                        name=""
                        class="comment-control"
                        cols="20"
                        rows="10"
                        v-model="comment"
                        v-on:keyup.enter="newComment(post.id, index)"
                        placeholder="Write a comment..."
                      ></textarea>
                    </div>
                    <span @click="newComment(post.id, index)">
                      <i><svg-icon name="message" /></i>
                    </span>
                  </div>
                </div>
              </div>
              <ion-infinite-scroll
                @ionInfinite="infiniteHandler($event)"
                threshold="100px"
                id="infinite-scroll"
                :disabled="$store.state.showLoader"
              >
                <ion-infinite-scroll-content
                  loading-spinner="bubbles"
                  loading-text="Loading more data..."
                >
                </ion-infinite-scroll-content>
              </ion-infinite-scroll>
            </div>

            <div class="right-container">
              <div class="messages">
                <div class="title">
                  <h3>Messages</h3>
                  <i><svg-icon name="envelope-check" /></i>
                </div>
                <div class="search-bar flex">
                  <i><svg-icon name="search" /></i>
                  <input
                    type="search"
                    name=""
                    id="message-search"
                    placeholder="Search Messages"
                  />
                </div>
                <div class="category">
                  <h5 class="active">Primary</h5>
                  <h5>General</h5>
                  <h5 class="messages-requests">
                    Requests
                    <span v-if="friendRequests.length != 0"
                      >({{ friendRequests.length }})</span
                    >
                  </h5>
                </div>
                <div class="primary-messages shift-wrapper">
                  <div
                    class="message"
                    v-for="(chat, index) in $store.state.users.slice(0, 4)"
                    :key="index"
                  >
                    <div
                      class="profile-image"
                      v-if="
                        $store.state.authuser &&
                        chat.sender.id == $store.state.authuser.id
                          ? chat.receiver &&
                            chat.receiver.image !== $store.state.avatar
                          : chat.sender &&
                            chat.sender.image !== $store.state.avatar
                      "
                    >
                      <img
                        :src="
                          $store.state.authuser &&
                          chat.sender.id == $store.state.authuser.id
                            ? `${this.$store.state.endpoints.appUrl}${chat.receiver.image}`
                            : `${this.$store.state.endpoints.appUrl}${chat.sender.image}`
                        "
                        alt=""
                      />
                    </div>
                    <div v-else>
                      <avatar
                        :username="
                          $store.state.authuser &&
                          chat.sender.id == $store.state.authuser.id
                            ? chat.receiver.username
                            : chat.sender.username
                        "
                        style="width: 40px; height: 40px"
                      ></avatar>
                    </div>
                    <div class="message-body">
                      <h5 v-if="chat.sender.id == $store.state.authuser.id">
                        {{ chat.receiver.username }}
                      </h5>
                      <h4 v-else>{{ chat.sender.username }}</h4>
                      <p class="text">{{ chat.text }}</p>
                    </div>
                  </div>
                </div>
                <div class="general-messages shift-wrapper">
                  <div
                    class="message"
                    v-for="(chat, index) in $store.state.users"
                    :key="index"
                  >
                    <div
                      class="profile-image"
                      v-if="
                        $store.state.authuser &&
                        chat.sender.id == $store.state.authuser.id
                          ? chat.receiver &&
                            chat.receiver.image !== $store.state.avatar
                          : chat.sender &&
                            chat.sender.image !== $store.state.avatar
                      "
                    >
                      <img
                        :src="
                          $store.state.authuser &&
                          chat.sender.id == $store.state.authuser.id
                            ? `${this.$store.state.endpoints.appUrl}${chat.receiver.image}`
                            : `${this.$store.state.endpoints.appUrl}${chat.sender.image}`
                        "
                        alt=""
                      />
                    </div>
                    <div v-else>
                      <avatar
                        :username="
                          $store.state.authuser &&
                          chat.sender.id == $store.state.authuser.id
                            ? chat.receiver.username
                            : chat.sender.username
                        "
                        style="width: 40px; height: 40px"
                      ></avatar>
                    </div>
                    <div class="message-body">
                      <h5 v-if="chat.sender.id == $store.state.authuser.id">
                        {{ chat.receiver.username }}
                      </h5>
                      <h4 v-else>{{ chat.sender.username }}</h4>
                      <p class="text">{{ chat.text }}</p>
                    </div>
                  </div>
                </div>
                <div class="message-requests shift-wrapper"></div>
              </div>

              <div class="friend-requests">
                <h4>Requests</h4>
                <div
                  class="request"
                  v-for="(contact, index) in friendRequests"
                  :key="index"
                >
                  <div class="info">
                    <div class="profile-image">
                      <img
                        :src="`${this.$store.state.endpoints.appUrl}${contact.sender.image}`"
                        alt=""
                        v-if="contact.sender.image !== $store.state.avatar"
                      />
                      <avatar
                        :username="contact.sender.username"
                        style="width: 2.7rem; height: 2.7rem"
                        v-else
                      ></avatar>
                    </div>
                    <div>
                      <h5>{{ contact.sender.username }}</h5>
                      <div class="people-suggestions" v-if="contact.mutual">
                        <span
                          v-for="(cont, index) in contact.mutual.friends"
                          :key="index"
                        >
                          <img
                            :src="`${this.$store.state.endpoints.appUrl}${cont.user.image}`"
                            alt=""
                            v-if="cont.user.image !== $store.state.avatar" />
                          <avatar
                            :username="cont.user.username"
                            style="width: 1.4rem; height: 1.4rem"
                            v-else
                          ></avatar
                        ></span>
                        <p v-if="contact.mutual">
                          &nbsp;{{ contact.mutual.mutual_count }} Mutual
                          Friend<em v-if="contact.mutual.mutual_count != 1"
                            >s</em
                          >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="tendo-btns">
                    <button
                      class="btn btn-accept"
                      @click="
                        acceptFriendRequest(
                          contact.id,
                          index,
                          contact.sender.username,
                          contact.sender.id
                        )
                      "
                    >
                      Accept
                    </button>
                    <button
                      class="btn btn-decline"
                      @click="declineFriendRequest(contact.id, index)"
                    >
                      Decline
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  IonApp,
  IonPage,
  IonContent,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
} from "@ionic/vue";
import HeaderSection from "./navBar/header.vue";
import moment from "moment";
import reads from "../reads/reads.container.vue";
import VueStar from "../animate/index.vue";
import Avatar from "../Avatar.vue";
import SvgIcon from "../SvgIcon.vue";
import VueSkeletonLoader from "../skeletonLoader/Loader.vue";
import NavigatorShare from "vue-navigator-share";
import FeedReactions from "../FeedReactions.vue";
import { inject } from "vue";
import CreatePoll from "../poll/createPol.vue";
import VuePoll from "../poll/id";
const { isImageFile, isVideoFile } = require("../../utils/mediaFile");
import vClickOutside from "click-outside-vue3";
import { events } from "../../events";
export default {
  directives: {
    clickOutside: vClickOutside.directive,
  },
  components: {
    IonApp,
    IonPage,
    IonContent,
    HeaderSection,
    IonInfiniteScroll,
    IonInfiniteScrollContent,
    reads,
    Avatar,
    SvgIcon,
    VueSkeletonLoader,
    VueStar,
    NavigatorShare,
    FeedReactions,
    CreatePoll,
    VuePoll,
  },
  inject: ["messaging"],
  data() {
    return {
      question: null,
      answer: [],
      comment: null,
      search: null,
      lastPage: null,
      friendRequests: [],
      checked: [],
      description: "",
      file: null,
      imageFile: [],
      videoFile: [],
      isImage: null,
      isVideo: null,
      value: [],
      status: "Who can see your post?",
      files: [],
      uploadPercentage: 0,
      parent: "",
    };
  },
  methods: {
    like(id, index) {
      // this.$store.state.feeds[index].your_reaction = { reaction: "❤️" };
    },
    closePicker() {
      window.HyreadsEvents.emit(events.CLOSE_ALL_REACTION_PICKERS);
    },
    onChangeInput() {
      this.resizeTextarea();
    },
    resizeTextarea() {
      const el = this.$refs["roomTextarea"];

      if (!el) return;
      if (typeof window !== "undefined") {
        const padding = window
          .getComputedStyle(el, null)
          .getPropertyValue("padding-top")
          .replace("px", "");

        el.style.height = 0;
        el.style.height = el.scrollHeight - padding * 2 + "px";
      }
    },
    newComment(id, index) {
      let formData = new FormData();
      formData.append("feed_id", id);
      formData.append("parent", this.parent);
      formData.append("content", this.comment);
      axios
        .post(`${this.$store.state.endpoints.newComment}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          },
        })
        .then((response) => {
          this.$store.state.feeds[index].comments.push(response.data.data);
        });

      this.comment = null;
      this.$store.state.feeds[index].commentBox = false;
    },
    removeFile(index) {
      this.imageFile.splice(index, 1);
      // this.isImageFile = null
      this.files.splice(index, 1);
    },
    removeFile1(index) {
      this.videoFile.splice(index, 1);
      //     this.isVideoFile = null
      this.files.splice(index, 1);
    },
    async onFileChange(files) {
      for (var f in files) {
        const file = files[f];
        const fileURL = URL.createObjectURL(file);
        const blobFile = await fetch(fileURL).then((res) => res.blob());
        const typeIndex = file.name.lastIndexOf(".");

        this.file = {
          blob: blobFile,
          name: file.name.substring(0, typeIndex),
          size: file.size,
          type: file.type,
          extension: file.name.substring(typeIndex + 1),
          localUrl: fileURL,
        };

        this.files.push(file);

        if (isImageFile(this.file)) {
          this.imageFile.push(fileURL);
          this.isImage = fileURL;
        } else if (isVideoFile(this.file)) {
          this.videoFile.push(fileURL);
          this.isVideo = fileURL;
        }
      }
    },
    feed() {
      let formData = new FormData();
      formData.append("description", this.description);
      formData.append("status", this.$refs.status.value);
      formData.append("answers", this.answer);
      formData.append("question", this.question);
      formData.append(
        "city",
        this.$store.state.userCurrentLocation.location.city
      );
      formData.append(
        "country_name",
        this.$store.state.userCurrentLocation.location.country_name
      );
      formData.append("os_type", this.$store.state.userCurrentLocation.os_type);
      formData.append(
        "device_type",
        this.$store.state.userCurrentLocation.device_type
      );
      formData.append("tags", JSON.stringify(this.checked));
      for (var i = 0; i < this.files.length; i++) {
        let file = this.files[i];
        formData.append("files", file);
      }
      axios
        .post(`${this.$store.state.endpoints.newFeed}`, formData, {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          onUploadProgress: (progressEvent) => {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          },
        })
        .then((response) => {
          console.log();
          document.getElementById("closeBtn").click();
          this.$store.state.feeds.unshift({
            city: response.data.data.city,
            country_name: response.data.data.country_name,
            created_at: response.data.data.created_at,
            description: response.data.data.description,
            device_type: response.data.data.device_type,
            id: response.data.data.id,
            os_type: response.data.data.os_type,
            status: response.data.data.status,
            updated_at: response.data.data.updated_at,
            user: this.$store.state.authuser,
            images: response.data.data.images,
            videos: response.data.data.videos,
            reacts: response.data.data.reacts,
            likes: response.data.data.likes,
            tags: response.data.data.tags,
          });
          this.description = "";
          this.value = "";
          this.checked = [];
          (this.files = []), (this.imageFile = []);
          this.videoFile = [];
          this.$refs.roomTextarea.value = "";
          this.uploadPercentage = 0;
        });
    },
    userIdObj(id) {
      return { name: id };
    },
    commentBox(id, index) {
      this.$store.state.feeds[index].commentBox = true;
    },
    getHumanDate: function (date) {
      return moment(String(date)).fromNow();
    },
    declineFriendRequest(pending_friend_request_id, index) {
      axios
        .get(
          `${this.$store.state.endpoints.declineFriendRequest}${pending_friend_request_id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          }
        )
        .then(() => {
          console.log(pending_friend_request_id);
        });
      this.friendRequests.splice(index, 1);
    },
    acceptFriendRequest(pending_friend_request_id, index, username, id) {
      axios
        .get(
          `${this.$store.state.endpoints.acceptFriendRequest}${pending_friend_request_id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
          }
        )
        .then(() => {
          console.log(pending_friend_request_id);
          this.$store.dispatch("stories");
        });
      this.friendRequests.splice(index, 1);
      setTimeout(() => {
        axios
          .post(
            `${this.$store.state.endpoints.createMessagesUrl}${id}/`,
            {
              message: `Hello (${username})
              `,
              sender_id: this.$store.state.authuser.id,
            },
            { headers: { Authorization: `Bearer ${this.$store.state.jwt}` } }
          )
          .then(() => {
            console.log();
          });
      }, 3000);
    },
    infiniteHandler(event) {
      setTimeout(() => {
        axios
          .get(
            `${this.$store.state.endpoints.feeds}?page=${this.$store.state.feedPage}`,
            {
              headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
            }
          )
          .then((response) => {
            if (response.data.data.length > 0) {
              this.lastPage = response.data.last_page;
              response.data.data.forEach((message) => {
                this.$store.state.feeds.push(message);
              });
              if (this.$store.state.feedPage === response.data.last_page) {
                this.$store.state.feedPage = response.data.last_page;
                event.target.complete();
                this.$store.state.showLoader = true;
              } else {
                this.$store.state.feedPage += 1;
              }
            } else {
              this.$store.state.feedPage = response.data.last_page;

              event.target.complete();
              this.$store.state.showLoader = true;
            }
          })
          .catch((e) => console.log(e));
      }, 1000);
    },
  },
  mounted() {
    console.log("Firebase cloud messaging object", this.$messaging);
    this.messaging
      .getToken({
        vapidKey:
          "BMWxsbgn_yvWC3zxqLr68FK7O6_GTgVdb4pAlk4CDoRo2LTmtIXxegATWhOvzCV7CiNkEuW-lDkZbQcQJyJDUPY",
      })
      .then((currentToken) => {
        if (currentToken) {
          console.log("client token", currentToken);
          axios
            .post(
              `${this.$store.state.endpoints.registerNotifTokenURL}`,
              { registration_id: currentToken, type: "web" },
              {
                headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
              }
            )
            .then((response) => {
              console.log(response.data);
            });
        } else {
          console.log(
            "No registration token available. Request permission to generate one."
          );
        }
      })
      .catch((err) => {
        console.log("An error occurred while retrieving token. ", err);
      });
    axios
      .get(
        `${this.$store.state.endpoints.friendRequests}${this.$store.state.authuser.id}/`,
        {
          headers: { Authorization: `Bearer ${this.$store.state.jwt}` },
        }
      )
      .then((response) => {
        this.friendRequests = response.data;
        console.log();
      });
    //shifting messages
    const shiftBtns = document.querySelectorAll(".category h5");
    const shiftWrappers = document.querySelectorAll(".shift-wrapper");

    function showActive(index) {
      shiftBtns.forEach((item) => {
        item.classList.remove("active");
      });
      shiftBtns[index].classList.add("active");

      shiftWrappers.forEach((tab) => {
        tab.style.display = "none";
      });
      shiftWrappers[index].style.display = "block";
    }

    showActive(0);

    for (let i = 0; i < shiftBtns.length; i++) {
      shiftBtns[i].addEventListener("click", () => {
        showActive(i);
      });
    }

    const modal_Interface = document.getElementById("modal-interface");
    const modalBox = document.getElementById("modal-content");
    const postBox = document.getElementById("create-post");
    const closeBtn = document.getElementById("closeBtn");
    if (postBox) {
      postBox.addEventListener("click", () => {
        modal_Interface.style.display = "flex";
        modalBox.classList.add("zoomIn");
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener("click", () => {
        modal_Interface.style.display = "none";
      });
    }

    window.addEventListener("click", (e) => {
      if (e.target == modal_Interface) {
        modal_Interface.style.display = "none";
      }
    });

    //tag implementation
    const exitTagBtn = document.querySelector(".remove-tags-btn");
    const tagPage = document.querySelector(".tag-body");
    const tagsBtn = document.querySelector(".tagBtn");
    const exitDoneBtn = document.querySelector(".remove-exit-btn");
    if (tagsBtn) {
      tagsBtn.addEventListener("click", function () {
        tagPage.style.display = "block";
      });
    }
    if (exitTagBtn) {
      exitTagBtn.addEventListener("click", function () {
        tagPage.style.display = "none";
      });
    }
    if (exitDoneBtn) {
      exitDoneBtn.addEventListener("click", function () {
        tagPage.style.display = "none";
      });
    }

    const fileTrigger = document.querySelector("#read-file");
    const fileBtn = document.getElementById("uploadBtn");
    const imagePreviewContainer = document.querySelector(".file-preview");
    const imagePrev = document.querySelector(".image-preview");
    if (fileBtn) {
      fileBtn.addEventListener("click", () => {
        fileTrigger.click();

        fileTrigger.addEventListener("change", function () {
          const file = this.files[0];
        });
      });
    }

    //poll implementation
    const exitPollBtn = document.querySelector(".remove-polls-btn");
    const pollPage = document.querySelector(".poll-body");
    const pollsBtn = document.querySelector(".pollBtn");
    if (pollsBtn) {
      pollsBtn.addEventListener("click", function () {
        pollPage.style.display = "block";
      });
    }
    if (exitPollBtn) {
      exitPollBtn.addEventListener("click", function () {
        pollPage.style.display = "none";
      });
    }
    if (exitPollBtn) {
      exitPollBtn.addEventListener("click", function () {
        pollPage.style.display = "none";
      });
    }

    var self = this;

    window.HyreadsEvents.on(events.POLL_CREATED, () => {
      document.getElementById("closeBtn").click();
    });
  },
  computed: {
    allTags() {
      if (this.search) {
        return this.$store.state.tags.filter((item) => {
          return this.$store.state.authuser &&
            item.sender.id == this.$store.state.authuser.id
            ? item.receiver.username
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1
            : item.sender.username
                .toLowerCase()
                .indexOf(this.search.toLowerCase()) > -1;
        });
      } else {
        return this.$store.state.tags;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// @import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@500;700&display=swap");
@import "./../styles/font-opensans.css";
@import "./../styles/font-fresca.css";
@import "./../styles/font-quicksand.css";
@import "./../styles/font-poppins.css";

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
ul {
  list-style: none;
}
a {
  text-decoration: none;
}
body {
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  background: #f5f5f5; /* Light gray background */
}

ion-content {
  --ion-background-color: #f5f5f5; /* Light gray background */
  --ion-font-family: "Poppins", sans-serif;
}

.inner-row {
  width: 85%;
  margin: auto;
}
.profile-image {
  width: 2.7rem;
  aspect-ratio: 1/1;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  box-shadow: 0px 0px 1px 1px gainsboro;
}
img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

header {
  width: 100%;
  background: white;
  position: fixed;
  z-index: 10;
  height: 70px;
  box-shadow: 0px 1px 2px rgb(231, 231, 231);
}
header .inner-row {
  height: inherit;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.header .logo-section {
  width: 40px;
  height: 40px;
}
.logo-section img {
  width: 45px;
}
.left-nav,
.right-nav {
  display: flex;
  align-items: center;
}

header .search-bar {
  background: whitesmoke;
  margin-left: 5%;
  width: 300px;
  padding: 0.5rem;
  border-radius: 1.2rem;
  -webkit-border-radius: 1.2rem;
  -moz-border-radius: 1.2rem;
  -ms-border-radius: 1.2rem;
  -o-border-radius: 1.2rem;
}
.search-control {
  border: none;
  background: transparent;
  outline: none;
  width: 80%;
  font-family: "Quicksand", sans-serif;
  color: #333;
}
.quick-links {
  margin-right: 5%;
  display: flex;
}
.quick-links .notify,
.quick-links .message {
  font-size: 1.5rem;
  cursor: pointer;
  color: rgb(80, 80, 80);
}
.profile-section {
  display: flex;
  align-items: center;
}
.profile-name {
  display: flex;
  align-items: center;
}
.profile-name h2 {
  font-size: 0.9rem;
  margin-left: 0.5rem;
  color: rgb(80, 80, 80);
}
.profile-name span {
  font-size: 1.2rem;
  cursor: pointer;
}

.mobile-navigation {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  background: #fff;
  z-index: 99;
  display: none;
  justify-content: space-around;
  padding: 0.5rem 0;
  border-top: 1px solid gainsboro;
}
.mobile-nav-item a {
  color: #333;
}
.mobile-nav-item i {
  font-size: 1.3rem;
}

.mobile-sidebar {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: -100%;
  transition: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -ms-transition: all 1s ease;
  -o-transition: all 1s ease;
}
.mobile-sidebar.active {
  height: 100%;
  position: fixed;
  right: 0;
  bottom: 0;
  z-index: 9;
  background: white;
  width: 50%;
  padding: 4rem 0.5rem;
  box-shadow: 0px 1px 1px 1px rgb(163, 163, 163);
  margin-right: 0;
}
.mobile-nav-link {
  display: block;
  line-height: 40px;
  color: #222;
  font-size: 0.9rem;
}

.mobile-profile {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  margin: 1rem 0;
}
.mobile-profile .profile-text p {
  font-size: 0.7rem;
  color: #444;
}
.mobile-sidebar .logout {
  padding: 0.5rem 0;
  margin-top: 1rem;
  border-top: 1px solid gainsboro;
}
.mobile-sidebar .logout a {
  font-size: 0.9rem;
  color: #222;
}

.navTrigger {
  cursor: pointer;
  width: 30px;
  height: 25px;
  margin: auto;
  position: absolute;
  right: 20px;
  top: 20px;
  display: none;
  z-index: inherit;
}
.navTrigger i {
  background: #222;
  width: 100%;
  content: "";
  display: block;
  height: 4px;
  border-radius: 2px;
  -webkit-border-radius: 2px;
  -moz-border-radius: 2px;
  -ms-border-radius: 2px;
  -o-border-radius: 2px;
}
.navTrigger i:nth-child(1) {
  animation: outTp 0.8s backwards;
  -webkit-animation: outTp 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(2) {
  margin: 5px 0;
  animation: outMd 0.8s backwards;
  -webkit-animation: outMd 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger i:nth-child(3) {
  animation: outBtm 0.8s backwards;
  -webkit-animation: outBtm 0.8s backwards;
  animation-direction: reverse;
}
.navTrigger.active i:nth-child(1) {
  -webkit-animation: inTp 0.8s forwards;
  animation: inTp 0.8s forwards;
}

.navTrigger.active i:nth-child(2) {
  -webkit-animation: inMd 0.8s forwards;
  animation: inMd 0.8s forwards;
}

.navTrigger.active i:nth-child(3) {
  -webkit-animation: inBtm 0.8s forwards;
  animation: inBtm 0.8s forwards;
}
/*Keyframes*/
@keyframes inMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes outMd {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes inTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes outTp {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes inBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@keyframes outBtm {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

.create-modal-popup {
  position: fixed;
  top: 0;
  width: 100%;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.86);
  z-index: 999;
  display: none;
  justify-content: center;
  align-items: center;
}
.create-modal-popup .modal-content {
  width: 450px;
  border-radius: 0.5rem;
  max-height: 600px;
  background-color: #fff;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  box-shadow: 0px 0px 2px 1px rgb(211, 211, 211);
  overflow-y: scroll;
  // position:relative;
  scrollbar-width: none;
}
.modal-content .modal-header {
  text-align: center;
  position: relative;
  padding: 0.8rem 0;
  border-bottom: 1px solid gainsboro;
  margin-bottom: 0.5rem;
}
.modal-header h3 {
  font-size: 1.2rem;
}
.modal-header .cancel {
  position: absolute;
  right: 0.2rem;
  cursor: pointer;
  top: 10px;
}
.modal-header .cancel i {
  font-size: 1.5rem;
}

.modal-body {
  padding: 0.5rem 1rem;
}
.modal-body .modal-title {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
}

.textarea-control {
  font-family: "Quicksand";
  font-size: 1rem;
  border: none;
  outline: none;
  padding-left: 0.2rem;
  width: 100%;
  resize: none;
}

.file-preview {
  width: 100%;
  height: 300px;
  margin: 1rem 0;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: none;
}
.file-preview img {
  object-fit: cover;
  display: none;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}
::-webkit-scrollbar {
  width: 0;
}
.additions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding:0.8rem 0.5rem;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}
.addition {
  border: 1px solid rgb(182, 180, 180);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8rem 0.5rem;
  border-radius: 0.5rem;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  margin-bottom: 0.5rem;
}
.additions h2 {
  font-size: 1rem;
  color: #444;
  font-weight: 500;
}
.additions .upload {
  width: 100%;
  /* height: 25px; */
  cursor: pointer;
}
.addition .upload {
  width: fit-content;
  height: 25px;
  /* cursor: pointer; */
  display: flex;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 20px;
}

.post-submitt {
  width: 100%;
  display: block;
  padding: 0.8rem 0;
  font-family: "Quicksand";
  font-size: 0.8rem;
  margin-bottom: 1rem;
  font-weight: 600;
  color: white;
  background: rgb(0, 110, 255);
  border: none;
  border-radius: 5px;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  -ms-border-radius: 5px;
  -o-border-radius: 5px;
  cursor: pointer;
}
.zoomIn {
  animation: zoomIn 0.5s ease-in;
  -webkit-animation: zoomIn 0.5s ease-in;
}

@keyframes zoomIn {
  from {
    opacity: 0;
    -webkit-transform: scale3d(0.3, 0.3, 0.3);
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
}

.tag-body {
  position: absolute;
  top: 0;
  bottom: 0;
  height: auto;
  display: none;
  width: 450px;
  border-radius: 0.5rem;
  max-height: 600px;
  background-color: #fff;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  box-shadow: 0px 0px 2px 1px lightgrey;
  overflow-y: scroll;
  z-index: 999;
}

@media (max-width: 550px) {
  .tag-body {
    position: absolute;
    top: 0;
    bottom: 0;
    height: auto;
    display: none;
    width: 100%;
    border-radius: 0.5rem;
    max-height: 600px;
    background-color: #fff;
    -webkit-border-radius: 0.5rem;
    -moz-border-radius: 0.5rem;
    -ms-border-radius: 0.5rem;
    -o-border-radius: 0.5rem;
    box-shadow: 0px 0px 2px 1px lightgrey;
    overflow-y: scroll;
    z-index: 999;
  }
}

.poll-body {
  position: absolute;
  top: 0;
  bottom: 0;
  height: auto;
  display: none;
  width: 450px;
  border-radius: 0.5rem;
  max-height: 500px;
  background-color: #fff;
  -webkit-border-radius: 0.5rem;
  -moz-border-radius: 0.5rem;
  -ms-border-radius: 0.5rem;
  -o-border-radius: 0.5rem;
  box-shadow: 0px 0px 2px 1px lightgrey;
  overflow-y: scroll;
  z-index: 999;
}

@media (max-width: 380px) {
  .poll-body {
    position: absolute;
    top: 0;
    bottom: 0;
    height: auto;
    display: none;
    width: 100%;
    border-radius: 0.5rem;
    max-height: 600px;
    background-color: #fff;
    -webkit-border-radius: 0.5rem;
    -moz-border-radius: 0.5rem;
    -ms-border-radius: 0.5rem;
    -o-border-radius: 0.5rem;
    box-shadow: 0px 0px 2px 1px lightgrey;
    overflow-y: scroll;
    z-index: 999;
  }
}
.post-progress-boddy {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  background: white;
  display: none;
}

.post-progress-boddy span {
  position: fixed;

  justify-content: center;
  align-items: center;
  top: 50%;
  left: 45%;
  right: 45%;
}

.tag-title {
  padding: 0.7rem;
  display: flex;
  gap: 7rem;
  align-items: center;
  border-bottom: 1px solid gainsboro;
  // position:absolute;
  top: 0;
  background-color: white;
  margin-bottom: 15px;
}
.tag-title span {
  font-size: 25px;
  cursor: pointer;
  background-color: rgb(247, 247, 247);
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}
.tag-title span:hover {
  background-color: gainsboro;
  transition: all 1s linear;
  -webkit-transition: all 1s linear;
  -moz-transition: all 1s linear;
  -ms-transition: all 1s linear;
  -o-transition: all 1s linear;
}

.tag-title h2 {
  font-size: 1.5rem;
}

.tag-search {
  display: flex;
  justify-content: space-between;
  margin: 1rem;
}
.search-box {
  background-color: rgb(235, 234, 234);
  width: 80%;
  padding: 0.4em;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  display: flex;
  gap: 0.5rem;
}
.search-box .search-friends {
  border: none;
  background: transparent;
  outline: none;
  font-family: "Quicksand";
  width: 100%;
}
.tag-search button {
  background: transparent;
  font-family: "Quicksand";
  border: none;
  font-weight: 600;
  color: rgb(0, 110, 255);
  cursor: pointer;
}

.suggestions {
  width: 90%;
  margin: auto;
  height: 400px;
  overflow-y: scroll;
  scrollbar-width: none;
}

.suggestions1 {
  width: 80%;
  margin-left: auto;
  margin-right: auto;
  margin-top: auto;
  margin-bottom: auto;
  height: 400px;
  overflow-y: scroll;
  scrollbar-width: none;
}

@media (max-width: 380px) {
}

.tag-body h3 {
  width: 90%;
  margin: 0 auto 0.5rem auto;
  font-size: 1rem;
}
.suggestions .friend {
  display: flex;
  margin-bottom: 1rem;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
}

.suggestions .friend-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.main-wrapper {
  position: relative;
  top: 6rem;
  font-family: "Poppins", sans-serif;
  font-weight: 500;
  background: #f5f5f5; /* Light gray background */
}

.main-wrapper .inner-row {
  display: grid;
  grid-template-columns: 20vw auto 22vw auto;
  column-gap: 30px;
}
.sidebar {
  position: sticky;
  top: 6rem;
  background: #fff;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
}
.sidebar .nav-link {
  display: flex;
  align-items: center;
  height: 3rem;
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -moz-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  position: relative;
}
.sidebar .nav-link:hover {
  background: rgb(247, 250, 252);
}
.sidebar .nav-link i {
  font-size: 1.5rem;
  margin-left: 1.5rem;
  color: rgb(92, 92, 92);
}
.sidebar .nav-link span {
  color: #333;
}
.nav-link.active {
  background: rgb(247, 250, 252);
}
.nav-link.active span,
.nav-link.active i {
  color: rgb(0, 110, 255);
}

.nav-link.active::before,
.nav-link:hover::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  width: 0.3rem;
  height: 100%;
  background: rgb(0, 110, 255);
}
.nav-link:first-child.active {
  border-top-left-radius: 0.5rem;
  overflow: hidden;
}
.nav-link:last-child.active,
.nav-link:last-child:hover {
  border-bottom-left-radius: 0.5rem;
  overflow: hidden;
}

.middle-container .reads {
  display: flex;
  justify-content: space-between;
  height: 10rem;
  gap: 0.5rem;
}
.reads .read {
  padding: 1rem;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  color: white;
  font-size: 0.75rem;
  width: 100%;
  position: relative;
  overflow: hidden;
}
.reads .read .profile-image {
  border: 2px solid rgba(0, 110, 255, 0.582);
  width: 2rem;
  height: 2rem;
  align-self: start;
}
.reads .read::before {
  content: "";
  display: block;
  width: 100%;
  height: 5rem;
  background: linear-gradient(transparent, rgba(0, 0, 0, 0.75));
  position: absolute;
  bottom: 0;
  z-index: 1;
}
.read .name {
  z-index: 2;
}
.reads .read:nth-child(1) {
  background: url("https://hyreads.com/images/read-bg1.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(2) {
  background: url("https://hyreads.com/images/read-bg2.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(3) {
  background: url("https://hyreads.com/images/read-bg3.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(4) {
  background: url("https://hyreads.com/images/read-bg4.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(5) {
  background: url("https://hyreads.com/images/read-bg5.jpg") no-repeat center
    center/cover;
}
.reads .read:nth-child(6) {
  background: url("https://hyreads.com/images/read-bg6.jpg") no-repeat center
    center/cover;
}

.btn-post {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  cursor: pointer;
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -moz-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  font-size: 0.8rem;
  border: none;
  font-family: "Quicksand", sans-serif;
  background: rgb(0, 110, 255);
  color: #fff;
}
.btn-post:hover {
  opacity: 0.8;
}
.create-post {
  margin: 1rem 0;
  display: flex;
  width: 100%;
  justify-content: space-between;
  background: white;
  padding: 0.4rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
}
.create-post input[type="text"] {
  justify-self: start;
  width: 100%;
  padding-left: 0.5rem;
  margin: 0 1rem 0 0.2rem;
  border: none;
  outline: none;
  font-family: "Quicksand", sans-serif;
}

/* -------Posts------*/
.middle-container .posts .post {
  background: #fff;
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  padding: 1rem;
  margin: 1rem 0;
  font-size: 0.85rem;
  line-height: 1.3rem;
}

.posts .post-head {
  display: flex;
  justify-content: space-between;
}
.post-head .user {
  display: flex;
  gap: 1rem;
}
.post-head .namlo {
  color: #333;
}
.post-head span {
  cursor: pointer;
}
.post .post-photo {
  overflow: hidden;
  margin: 0.7rem 0;
  // border-radius: 1rem;
  border-radius: 20px;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
}

.post .action-btns {
  // display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 1.3rem;
  margin: 0.5rem;
}
.action-btns span {
  cursor: pointer;
  position: relative;
}
.action-btns .interaction-btns {
  display: flex;
  align-items: center;
  padding-left: 35px;
  gap: 12px;
}

.post .people-likings {
  display: flex;
}
.people-likings span {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  border: 2px solid gainsboro;
  margin-left: -0.6rem;
}
.people-likings span:first-child {
  margin: 0;
}
.people-likings p {
  margin-left: 0.5rem;
}

.caption {
  margin: 0.3rem 0;
  color: #333;
  text-align: justify;
}
.comments {
  color: gray;
  cursor: pointer;
}

.right-container {
  height: max-content;
  position: sticky;
  top: 6rem;
}

.right-container .messages {
  background: #fff;
  padding: 1rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
}
.messages .title {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  align-items: center;
}
.messages .title i {
  font-size: 1.3rem;
}

.messages .search-bar {
  width: 100%;
  padding: 0.5rem;
  border-radius: 1.2rem;
  -webkit-border-radius: 1.2rem;
  -moz-border-radius: 1.2rem;
  -ms-border-radius: 1.2rem;
  -o-border-radius: 1.2rem;
  background: whitesmoke;
  margin-bottom: 1rem;
}
.messages .search-bar #message-search {
  border: none;
  background: transparent;
  outline: none;
  width: 80%;
  font-family: "Quicksand", sans-serif;
  color: #333;
}

.messages .category {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
}
.messages .category h5 {
  width: 100%;
  text-align: center;
  padding-bottom: 0.5rem;
  border-bottom: 2px solid rgb(196, 196, 196);
  font-size: 0.85rem;
  cursor: pointer;
}
.messages .category .active {
  border-color: royalblue;
}
.messages .message {
  display: flex;
  gap: 0.6em;
  margin-bottom: 1rem;
  align-items: center;
}
.messages .message:last-child {
  margin: 0;
}

.messages .message p {
  font-size: 0.8rem;
}
.message .profile-image {
  position: relative;
  overflow: visible;
}
.message .profile-image img {
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
}
.message .profile-image .active {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  background: rgb(0, 255, 0);
  position: absolute;
  bottom: 0.1rem;
  right: 0;
}

.right-container .friend-requests {
  margin-top: 1rem;
}
.friend-requests h4 {
  color: #333;
  margin: 1rem 0;
}
.friend-requests .request {
  border-radius: 1rem;
  -webkit-border-radius: 1rem;
  -moz-border-radius: 1rem;
  -ms-border-radius: 1rem;
  -o-border-radius: 1rem;
  background: white;
  padding: 1rem;
  margin-bottom: 1rem;
}
.request .info {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 1rem;
}
.request .info p {
  font-size: 0.75rem;
  color: #444;
}
.tendo-btns {
  display: flex;
  gap: 1rem;
}
.tendo-btns .btn {
  display: inline-block;
  padding: 0.5rem 1rem;
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  cursor: pointer;
  transition: all 300ms ease;
  -webkit-transition: all 300ms ease;
  -moz-transition: all 300ms ease;
  -ms-transition: all 300ms ease;
  -o-transition: all 300ms ease;
  font-size: 0.8rem;
  border: none;
  font-family: "Quicksand", sans-serif;
  color: #fff;
}
.tendo-btns .btn-accept {
  background: rgb(0, 110, 255);
}
.tendo-btns .btn-decline {
  background: rgba(255, 0, 0, 0.616);
}

/*=======Responsivity=========*/
@media (max-width: 1200px) {
  .inner-row {
    width: 95%;
  }

  .main-wrapper .inner-row {
    grid-template-columns: 4rem auto 30vw;
    gap: 1rem;
  }
  .sidebar {
    width: 4rem;
  }
  .sidebar span {
    display: none;
  }
  .sidebar .nav-link i {
    margin-left: 1rem;
  }
}

@media (max-width: 930px) {
  .right-container {
    display: none;
  }
  .main-wrapper .inner-row {
    grid-template-columns: 4rem auto;
    gap: 1rem;
  }
}
@media (max-width: 700px) {
  .navTrigger {
    display: block;
  }
  .middle-container {
    width: 100%;
    display: block;
    margin-bottom: 9rem;
  }
  .main-wrapper .inner-row {
    grid-template-columns: repeat(1, 1fr);
    display: block;
  }
  header .search-bar,
  .right-nav,
  .sidebar {
    display: none;
  }
  .mobile-navigation {
    display: flex;
  }
}

.post .sentence-post,
.post .video-post {
  margin: 1rem 0;
  border-radius: 50%;
}

.people-suggestions {
  display: flex;
}

.people-suggestions span {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  -ms-border-radius: 50%;
  -o-border-radius: 50%;
  overflow: hidden;
  border: 2px solid gainsboro;
  margin-left: -0.6rem;
}
.people-suggestions span:first-child {
  margin: 0;
}

.text {
  overflow: hidden;
  width: 180px;
  white-space: nowrap;
  text-overflow: ellipsis;
  line-height: 16px;
  max-height: 20px;
}

.create-comment {
  display: flex;
  width: 100%;
  align-items: center;
  gap: 0.5rem;
  margin: 1rem 0;
}
.create-comment .profile-image {
  width: 30px;
  height: 30px;
}
.input-comment {
  width: 85%;
}
.input-comment .comment-control {
  height: 40px;
  width: 100%;
  padding: 0.5rem;
  font-family: "Quicksand";
  border-radius: 1.5rem;
  -webkit-border-radius: 1.5rem;
  -moz-border-radius: 1.5rem;
  -ms-border-radius: 1.5rem;
  -o-border-radius: 1.5rem;
  background-color: #ddd;
  border: none;
  outline: none;
  resize: none;
  color: #333;
}
.comment-control::placeholder {
  font-size: 0.8rem;
}
.create-comment span {
  font-size: 30px;
  color: rgb(0, 110, 255);
  cursor: pointer;
}
</style>
